<template>
  <div>
    <div id="layout" class="Layout_layout__wKkIq zh-CN ltr layout-wrapper">
      <top-nav :shrinked="shrinked" :isAuto="true"/>
      <div class="main-site-page">
        <div class="TopSlider_topSliderWrapper__XjHlG">
          <div class="Carousel_carousel__rSN5L carousel" id="main1-carousel">
            <div class="slider TopSlider_topSlider__Ufzgp " dir="ltr">
              <div v-for="(item,index) in videos" :key="index">
                <div class="TopSlider_topSliderItem__2k9eb">
                  <div v-if="item.imageType" style="width: 100%; height: 100%;">
                    <picture>
                      <source :srcset="require('@/assets/'+item.imageType.desktop.src+'.jpg')" media="(max-width: 768px)">
                      <img :src="require('@/assets/'+item.imageType.desktop.src+'.png')" alt="" style="object-fit: cover;">
                    </picture>
                  </div>
                  <video
                      v-else
                      :id="'myVideo'+index"
                      class="BackgroundVideo_video__2hccC"
                      :poster="require('@/assets/'+item.poster+'.png')"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-video-player-type="h5"
                      muted
                  >
                    <source :src="require('@/assets/'+item.video.desktop.src+'.mp4')" type="video/mp4">
                  </video>
                  <div v-if="item.video" class="TopSlider_topSliderItemContent__3szl9">
                    <div class="TopSlider_topSliderItemButtons__ic5YM">
                      <a class="n-button n-button--large n-button--white" href="javascript:" title="了解详情" @click="goDwell">了解详情</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="Carousel_carouselControls__HecEP carouselControls">
              <div class="Carousel_carouselPagination__dClSG carouselPagination">
                <span v-for="(item,index) in videos" :key="index"
                      :class="{'carouselPaginationActive carouselPaginationItem':currentSlide === index}"
                      class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem Carousel_progressBar__5QsnB"
                      @click="paginationClick(index)">
                  <span class="Carousel_progressBarWrapper__9RZXQ">
                    <span class="Carousel_progressBarIndicator__Al0KD" :style="currentSlide === index?'width: 100%; transition: width 8s ease-in;':'width: 0%; transition: none;'">
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="VehicleSlider_vehicleSliderWrapper__GnfuV VehicleSlider_isMobileShort__JLLLv" id="vehicle-slider-wrapper">
            <h3 class="VehicleSlider_title__6rPrq">{{vehicleSlider.title}}</h3>
            <!--            <p class="VehicleSlider_description__X5kLf VehicleSlider_vehicleSliderDescription__q6TV0 VehicleSlider_inView__XTMDy">-->
            <!--              左右滑动查看更多-->
            <!--            </p>-->
            <div class="VehicleSlider_vehicleNavSliderWrapper__DxeM2 VehicleSlider_inView__XTMDy">
              <div class="Carousel_carousel__rSN5L carousel" id="vehicle-nav-slider">
                <div class="slider-nav VehicleSlider_vehicleSliderNav__PugCY VehicleSlider_centerMode__Q4FNC" dir="ltr">
                  <div class="slick-track">
                    <div v-for="(item,index) in vehicleSlider.vehicles"
                         :key="index"
                         @click="pagination1Click(index)">
                      <div
                          class="VehicleSlider_vehicleSliderNavItem__TLbHx"
                          :class="{'VehicleSlider_isActive__i51Dv':currentSlide1==index}">
                        <div>{{item.logo.desktop}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="VehicleSlider_vehicleSliderInnerWrapper__UOqKE VehicleSlider_inView__XTMDy">
              <div class="Carousel_carousel__rSN5L carousel" id="vehicle-slider">
                <div class="slider1 VehicleSlider_vehicleSlider__f1Hi3" dir="ltr">
                  <div v-for="(item,index) in vehicleSlider.vehicles" :key="index">
                    <div class="VehicleSlider_vehicleSliderItem__SIbRI" >
                      <picture class="responsive-image--picture">
                        <source :srcset="require('@/assets/yw/' + item.image.desktop)" media="(max-width: 1023px)">
                        <img :src="require('@/assets/yw/' + item.image.desktop)" class="ResponsiveImage_responsiveImage__OVw0A"  draggable="false">
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="VehicleSlider_vehicleSliderInnerWrapper__UOqKE VehicleSlider_vehicleTextSliderWrapper__or8NY">
              <div class="Carousel_carousel__rSN5L carousel" id="slider-carousel">
                <div class="VehicleSlider_vehicleSlider__f1Hi3 VehicleSlider_vehicleTextSlider__MU_4e" dir="ltr">
                  <div class="slick-list">
                    <div class="slick-track">
                      <div v-for="(item,index) in vehicleSlider.vehicles" :key="index" :style="currentSlide1==index?'opacity: 1;':''" style="outline: none; position: relative; opacity: 0; transition: opacity 500ms, visibility 500ms; left: 0px;margin-left: auto;margin-right: auto;" class="slick-slide" :class="{'slick-active':currentSlide1==index,'slick-current':currentSlide1==index}">
                        <div class="VehicleSlider_vehicleSliderItem__SIbRI" id="0" style="width:100%;display:inline-block">
                          <div class="VehicleSlider_vehicleSliderItemContent__J_twz">
                            <div class="VehicleSlider_vehicleSliderItemButtons__Kdjca">
                              <a class="n-button n-button--large n-button--bordered" href="javascript:;" @click="goPage(item,index)">{{item.buttons.label}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="NioHouseSection_ultraWideWrapper__BNEW8">
          <div class="NioHouseSection_nioHouse__4dz0J">
            <h5 class="NioHouseSection_description__Y9dWM">六恒科技系统</h5>
            <p class="NioHouseSection_learnMore__cENex">健康舒适的智慧居住环境，低碳节能的绿色环保建筑</p>
            <div class="NioHouseSection_banner__H7xNP" style="width:100%;">
              <div class="Carousel_carousel__rSN5L carousel" id="nio-carousel">
                <div class="slick-slider slick-initialized" dir="ltr">
                  <div>
                    <div class="NioHouseSection_bannerItem__PR43_" style="width:20%;display:inline-block;">
                      <picture class="responsive-image--picture">
                        <source srcset="@/assets/nio/banner.jpg" media="(max-width: 1023px)">
                        <img src="@/assets/nio/banner.jpg" alt="" title="" class="ResponsiveImage_responsiveImage__OVw0A" draggable="false">
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isMobile" class="NioHouseSection_carousel__xKpry">
              <div class="Carousel_carousel__rSN5L carousel" id="main-carousel">
                <div class="slick-slider slick-initialized" dir="ltr">
                  <div class="slick-list" style="opacity: 1">
                    <div class="slick-track slider3" style="width: 100%; opacity: 1; ">
                      <div v-for="(item,index) in nioHouse.sliders" :key="index" style="outline:none" data-index="1" class="slick-slide">
                        <div class="NioHouseSection_cardItem__bxgdZ">
                          <picture class="responsive-image--picture">
                            <source :srcset="require('@/assets/nio/' + item.src)" media="(max-width: 1023px)">
                            <img :src="require('@/assets/nio/' + item.src)" alt="Living Café" title="Living Café" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                          </picture>
                          <div class="NioHouseSection_cardDetail__ptGN3">
                            <img :src="require('@/assets/nio/' + item.logo)"
                                 class="ResponsiveImage_responsiveImage__OVw0A"
                                 draggable="false">
                            <div class="NioHouseSection_text__nhKc4">
                              <h3>{{item.title}}</h3>
                              <p>{{item.description}}
                                <p>{{item.subdesc}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Carousel_carouselControls__HecEP carouselControls">
                  <div class="Carousel_carouselPagination__dClSG carouselPagination">
                    <span v-for="(item,index) in nioHouse.sliders" :key="index"
                          class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                          :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':nioActive==index}">
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="NioHouseSection_carousel__xKpry">
              <div v-for="(item,index) in nioHouse.sliders" :key="index" class="NioHouseSection_cardItem__bxgdZ NioHouseSection_inView__lLhOa">
                <picture class="responsive-image--picture">
                  <source :srcset="require('@/assets/nio/' + item.src)" media="(max-width: 1023px)">
                  <img :src="require('@/assets/nio/' + item.src)" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                </picture>
                <div class="NioHouseSection_cardDetail__ptGN3">
                  <img :src="require('@/assets/nio/' + item.logo)"
                       class="ResponsiveImage_responsiveImage__OVw0A min-icon"
                       draggable="false">
                  <div class="NioHouseSection_text__nhKc4">
                    <h3>{{item.title}}</h3>
                    <p>{{item.description}}</p>
                    <p>{{item.subdesc}}</p>
                  </div>
                </div>
              </div>
            </div>
            <a class="NioButton_nio-button__L8ili NioButton_default__zkd5j NioButton_middle__AhnHO NioHouseSection_learnMoreButton__AS2Q1 NioButton_ghost__MjrCl NioButton_link__MVfQj" type="button" href="javascript:;" @click="toDwell">查看更多</a>
          </div>
        </div>

        <div>
          <div class="BSLSection_ultraWideWrapper__sUxog">
            <div class="BSLSection_blsContainer__RP8tV" id="blsContainer">
              <div>
                <div class="BSLSection_explore__iiHmE">
                  <h3>
                    6s深度生活服务
                    <div class="BSLSection_explore__desc">服务新里程 品质换美好</div>
                  </h3>
                  <div class="BSLSection_itemContainer__fETe6">
                    <a class="BSLSection_item__AbSIg BSLSection_inView__YtbFj" href="javascript:" @click="serviceClick">
                      <img src="@/assets/service/27.jpg" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                      <div class="BSLSection_item__AbSIg_mask">
                        <div>
                          <div class="en-title">SAFEGUARD</div>
                          <div class="hans-title">尊享</div>
                        </div>
                        <div class="hans-desc">省心安全 守护生活</div>
                      </div>
                    </a>
                    <a class="BSLSection_item__AbSIg BSLSection_inView__YtbFj" href="javascript:" @click="serviceClick">
                      <img src="@/assets/service/28.jpg" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                      <div class="BSLSection_item__AbSIg_mask">
                        <div>
                          <div class="en-title">SERVICE</div>
                          <div class="hans-title">个性</div>
                        </div>
                        <div class="hans-desc">创造标杆 服务尊崇</div>
                      </div>
                    </a>
                    <a class="BSLSection_item__AbSIg BSLSection_inView__YtbFj" href="javascript:" @click="serviceClick">
                      <img src="@/assets/service/29.jpg" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                      <div class="BSLSection_item__AbSIg_mask">
                        <div>
                          <div class="en-title">SOFTWARE</div>
                          <div class="hans-title">智能</div>
                        </div>
                        <div class="hans-desc">便捷享受 传递美好</div>
                      </div>
                    </a>
                    <a class="BSLSection_item__AbSIg BSLSection_inView__YtbFj" href="">
                      <img src="@/assets/service/30.jpg" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                      <div class="BSLSection_item__AbSIg_mask">
                        <div>
                          <div class="en-title">SHTSUKE</div>
                          <div class="hans-title">素养</div>
                        </div>
                        <div class="hans-desc">大美焕新 每日相遇</div>
                      </div>
                    </a>
                    <a class="BSLSection_item__AbSIg BSLSection_inView__YtbFj" href="javascript:" @click="serviceClick">
                      <img src="@/assets/service/31.jpg" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                      <div class="BSLSection_item__AbSIg_mask">
                        <div>
                          <div class="en-title">STUDY</div>
                          <div class="hans-title">关怀</div>
                        </div>
                        <div class="hans-desc">真挚善达 温暖相伴</div>
                      </div>
                    </a>
                    <a class="BSLSection_item__AbSIg BSLSection_inView__YtbFj" href="javascript:" @click="serviceClick">
                      <img src="@/assets/service/32.jpg" class="ResponsiveImage_responsiveImage__OVw0A " draggable="false">
                      <div class="BSLSection_item__AbSIg_mask">
                        <div>
                          <div class="en-title">SHARED</div>
                          <div class="hans-title">邻里</div>
                        </div>
                        <div class="hans-desc">时光共赏 全龄乐活</div>
                      </div>
                    </a>
                  </div>
                  <div class="Home_Cate_Button Home_6_Mar" @click="serviceClick">查看更多</div>
                </div>
              </div>
            </div>

            <div class="grid-content">
              <h3>新闻中心</h3>
              <div class="grid-bg">
                <div v-for="(item,index) in newsList"
                     class="grid-item"
                     :key="index"
                     data-aos="fade-up"
                     data-aos-once="true"
                     :data-aos-delay="index*100"
                     @click="newsClick(item,index)"
                >
                  <img :src="item.coverImage" @error="onImageError">
                  <div class="title-strong ellipsis" data-aos="fade-up" data-aos-delay="90" data-aos-once="true">{{item.title}}</div>
                  <div data-aos="fade-up" data-aos-delay="90" data-aos-once="true">
                    <div class="tip ellipsis" v-html="item.content"></div>
                  </div>
                </div>
              </div>
              <div class="Home_Cate_Button Home_News_Mar" @click="goNews">查看更多</div>
            </div>

            <div class="BSLSection_hero__J2oCe1">
              <div class="hero_content">
                <h2 class="text-blue">快速探索</h2>
              </div>
              <picture class="responsive-image--picture">
                <source srcset="@/assets/35.jpg" media="(max-width: 1023px)">
                <img src="@/assets/35.jpg" alt="" title="" class="ResponsiveImage_responsiveImage__OVw0A NewHero_heroBackgroundImage__wSIGk" draggable="false">
              </picture>
              <div class="BSLSection_hero__J2oCe1_bottom">
                <div class="BSLSection_hero__J2oCe1_Left">
                  <img src="@/assets/36.jpg">
                  <div class="Act_button" @click="goService">客服中心</div>
                </div>
                <div class="BSLSection_hero__J2oCe1_Right">
                  <div class="BSLSection_hero__J2oCe1_Right_Content">
                    <p>联系电话：0519-88160137</p>
                    <p>传真：0519-88160137</p>
                    <p>邮编：213000</p>
                    <p>集团总部地址：江苏省常州市延陵西路19号嘉宏世纪大厦33楼</p>
                    <p>400服务监督热线：400-828-9980</p>
                    <p>(工作时间：周一至周五8:30-17:30)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="TideNioApp_nio-app__FAUZv">
          <div class="TideNioApp_tideAppcontainer__hRWBn">
            <div class="TideNioApp_Left">
              <div class="TideNioApp_topContent__5mS6n" >
                <h3>
                  <div id="app-download" class="text-blue">码上看房
                    <br>
                    <span style="white-space:nowrap">点亮理想生活</span>
                  </div>
                </h3>
                <p>2024年7月1日-12月31日期间
                  <br>
                  <span style="white-space: nowrap;">通过掌上嘉推荐好友</span>
                  <br>即可领取全民专属奖励
                </p>
                <div class="Home_Cate_Button Home_App_Mar" style="opacity:0;">查看详情</div>
              </div>
              <div>
                <img src="@/assets/app.png" class="ResponsiveImage_responsiveImage__OVw0A TideNioApp_phoneImg___AQcZ" draggable="false">
              </div>
            </div>
            <div class="TideNioApp_secondSection__5dg7k">
              <div>
                <div class="TideNioApp_desktopQrcode__Lo4DyBg">
                  <div class="TideNioApp_desktopQrcode__Lo4Dy">
                    <img src="@/assets/37.png"
                         class="ResponsiveImage_responsiveImage__OVw0A "
                         draggable="false">
                  </div>
                </div>
                <div class="TideNioApp_desktopQrcode__Lo4DyBg">
                  <div class="TideNioApp_desktopQrcode__Lo4Dy">
                    <img src="@/assets/38.png"
                         class="ResponsiveImage_responsiveImage__OVw0A"
                         draggable="false">
                  </div>
                </div>
              </div>
              <div class="TideNioApp_privacyLinks__GA1W2">
                <a href="" class="TideNioApp_linkItem__q9h8P">
                  <p>扫码关注嘉宏官微</p>
                </a>
                <a href="" class="TideNioApp_linkItem__q9h8P">
                  <p>及时获取最新资讯</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="toast" class="Toast_toast__D3yKs"></div>
  </div>
</template>

<script>
/**
 * 引入api
 */
import {fetchSixList} from '@/api/news.js'
import {formatUrl} from '@/utils';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
import errorImg from '@/assets/error.jpg';
var that = null
import topNav from '@/components/base/top-nav'
export default {
  components: {
    topNav
  },
  data() {
    return {
      poster:'',
      menuActive: false,
      subMenu:[],
      newsList:[],
      menuId:'',
      imgSrc:'',
      shrinked:false,
      opaque:false,
      currentSlide: -1,
      currentSlide1: 0,
      nioActive: 0,
      scrollY:0,
      isScrollDown: true,
      domVisibleHeight: 20,
      isMobile: false,
      videoLoaded: false,
      posterSrc: null, // 封面图片的数据URL
      videos: [
        {
          poster: 'poster_00',
          buttons: [
            {
              label: "了解更多",
              href: "",
              "active": true
            }
          ],
          imageType: {
            desktop: {
              src: "poster_00",
              type: "image/jpg"
            },
            mobile: {
              src: "poster_00",
              type: "image/jpg"
            }
          }
        },
        {
          poster: 'poster_01',
          buttons: [
            {
              label: "了解更多",
              href: "",
              "active": true
            }
          ],
          imageType: {
            desktop: {
              src: "poster_01",
              type: "image/jpg"
            },
            mobile: {
              src: "poster_01",
              type: "image/jpg"
            }
          }
        },
        {
          poster: 'poster_1',
          buttons: [
            {
              label: "了解详情",
              href: "",
              "active": true
            }
          ],
          video: {
            desktop: {
              src: "a1",
              type: "video/mp4"
            },
            mobile: {
              src: "a1",
              type: "video/mp4"
            }
          }
        },
        {
          title: "",
          description: "",
          poster: 'poster_2',
          buttons: [
            {
              label: "了解更多",
              href: "",
              "active": true
            }
          ],
          video: {
            desktop: {
              src: "a2",
              type: "video/mp4"
            },
            mobile: {
              src: "a2",
              type: "video/mp4"
            }
          }
        },
        {
          title: "",
          description: "",
          poster: 'poster_3',
          buttons: [
            {
              label: "了解更多",
              href: "",
              "active": true
            }
          ],
          video: {
            desktop: {
              src: "a3",
              type: "video/mp4"
            },
            mobile: {
              src: "a3",
              type: "video/mp4"
            }
          }
        },
        {
          title: "",
          description: "",
          poster: 'poster_4',
          buttons: [
            {
              label: "了解更多",
              href: "",
              "active": true
            }
          ],
          video: {
            desktop: {
              src: "a4",
              type: "video/mp4"
            },
            mobile: {
              src: "a4",
              type: "video/mp4"
            }
          }
        },
        {
          title: "",
          description: "",
          poster: 'poster_5',
          buttons: [
            {
              label: "了解更多",
              href: "",
              "active": true
            }
          ],
          video: {
            desktop: {
              src: "a5",
              type: "video/mp4"
            },
            mobile: {
              src: "a5",
              type: "video/mp4"
            }
          }
        }
      ],
      vehicleSlider: {
        title: "探索嘉宏多元业务",
        description: "左右滑动以查看更多",
        arrows: true,
        fade: true,
        textSpeed: 500,
        vehicleSpeed: 700,
        initialSlide: 0,
        showCTASlider: true,
        vehicles: [
          {
            id: "dwell",
            title: "",
            logo: {
              desktop: "住宅开发",
              mobile: "住宅开发"
            },
            image: {
              desktop: "1.jpg",
              mobile: "1.jpg"
            },
            buttons: {
              label: "探索住宅开发",
              href: "dwell"
            },
            video: {
              desktop: {
                src: "",
                type: "video/mp4"
              },
              mobile: {
                src: "",
                type: "video/mp4"
              }
            }
          },
          {
            id: "business",
            title: "",
            logo: {
              desktop: "商业运营",
              mobile: "商业运营"
            },
            image: {
              desktop: "2.jpg",
              mobile: "2.jpg"
            },
            buttons: {
              label: "探索商业运营",
              href: "business"
            }
          },
          {
            id: "hotel",
            title: "",
            logo: {
              desktop: "酒店管理",
              mobile: "酒店管理"
            },
            image: {
              desktop: "4.jpg",
              mobile: "4.jpg"
            },
            buttons: {
              label: "探索酒店管理",
              href: "hotel"
            },
            video: {
              desktop: {
                "src": "",
                "type": "video/mp4"
              },
              mobile: {
                "src": "",
                "type": "video/mp4"
              }
            }
          },
          {
            id: "real",
            title: "",
            logo: {
              desktop: "物业服务",
              mobile: "物业服务"
            },
            image: {
              desktop: "3.jpg",
              mobile: "3.jpg"
            },
            buttons: {
              label: "探索物业服务",
              href: "real"
            }
          },
          {
            id: "exchange",
            title: "",
            logo: {
              desktop: "租售业务",
              mobile: "租售业务"
            },
            image: {
              desktop: "5.jpg",
              mobile: "5.jpg"
            },
            descriptionX: "",
            buttons: {
              label: "探索租售业务",
              href: "exchange"
            }
          }
        ]
      },
      nioHouse: {
        isActive: true,
        banners: [
          {
            mobile: "",
            desktop: "",
          }
        ],
        sliders: [
          {
            title: "四季如春",
            src: "img1.jpg",
            mobile: "",
            description: "夏季≤26℃，冬季>20℃",
            subdesc:"垂直温差≤3℃",
            logo: "icon1.png"
          },
          {
            title: "舒适滋润",
            src: "img2.jpg",
            mobile: "",
            description: "全年室内相对湿度",
            subdesc:"夏季≤70%，冬季≥30%",
            logo: "icon2.png"
          },
          {
            title: "空气清新",
            src: "img3.jpg",
            mobile: "",
            description: "室内CO₂,浓度<800ppm",
            subdesc:"整室新风换气次数:0.5-1次/时",
            logo: "icon3.png"
          },
          {
            title: "健康呼吸",
            src: "img4.jpg",
            mobile: "",
            description: "PM2.5过滤高达95%",
            subdesc:"甲醛≤0.08mg/m³",
            logo: "icon4.png"
          },
          {
            title: "静谧之境",
            src: "img5.jpg",
            mobile: "",
            description: "主要居住空间无主要设备",
            subdesc:"更安静35dB(A)",
            logo: "icon5.png"
          },
          {
            title: "智慧管家",
            src: "img6.jpg",
            mobile: "",
            description: "远程控制、自动调控环境可视",
            subdesc:"可整合智能家居/安防可视对讲等",
            logo: "icon6.png"
          }
        ],
        learnMore: {
          title: "更多精彩等你发掘",
          buttonLabel: "了解更多",
          buttonLink: ""
        }
      },
      cultureList:[
        {
          image:'1.png',
          title:'慈善关爱 传递温暖',
          tip:'嘉宏集团参加"同在一片蓝天下"慈善助孤残活动',
        },{
          image:'2.png',
          title:'同向而行 共创美好',
          tip:'天宁区领导一行来访交流',
        },{
          image:'3.png',
          title:'再获嘉奖 荣耀前行',
          tip:'热烈祝贺嘉宏集团荣登常州市多项荣誉榜',
        },{
          image:'4.png',
          title:'再获嘉奖 荣耀前行',
          tip:'热烈祝贺嘉宏集团荣登常州市多项荣誉榜',
        },{
          image:'5.png',
          title:'慈善关爱 传递温暖',
          tip:'嘉宏集团参加"同在一片蓝天下"慈善助孤残活动',
        },{
          image:'6.png',
          title:'同向而行 共创美好',
          tip:'天宁区领导一行来访交流',
        }
      ],
      currentVideo:null
    }
  },
  mounted() {
    that = this
    this.initSlider();
    this.resizeHandle();
    window.addEventListener("scroll", this.scrollEvent)
    window.addEventListener("resize", this.resizeHandle)
    this.fetchNewsList()
  },
  beforeDestroy() {
    console.log("beforeDestroy dateChange组件监听$off");
    window.removeEventListener('scroll',this.scrollEvent);
  },
  methods:{
    onImageError(event){
      // event.target.src = errorImg;
    },
    nioWidthInit(){
      let doms = document.getElementsByClassName('NioHouseSection_banner__H7xNP');
      if (!doms) {
        return;
      }
      for (var i = 0; i < doms.length; i++) {
        var dom = doms[i];
        var domRect = dom.getBoundingClientRect();
        console.log('window.innerHeight====',window.innerHeight)
        console.log('domRect.top====',domRect.top)
        // 计算元素顶部距离窗口顶部的高度
        var domVisibleHeight = window.innerHeight - domRect.top;
        // 如果元素距离窗口顶部的高度大于 100 像素，开始动画
        if (domVisibleHeight > 100) {
          that.domVisibleHeight = 100
          dom.style.width = that.domVisibleHeight + '%'
        }
      }
    },
    /**
     * 监听屏幕变化
     */
    resizeHandle(){
      that.initMobileSlider()
      this.updateAnimation()
    },
    initMobileSlider(){
      if(window.innerWidth <= 720){
        if(!this.isMobile){
          this.isMobile = true
          this.$nextTick(()=>{
            $('.slider3').slick({
              arrows: true,
              initialSlide: 0
            });
            $('.slider3').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
              that.nioActive = currentSlide
            });
          })
        }
      }else{
        this.isMobile = false
      }
    },
    /**
     *  监听滚动事件
     */
    scrollEvent(){
      if(window.scrollY > this.scrollY){
        this.isScrollDown = true
      }else{
        this.isScrollDown = false
      }
      this.scrollY = window.scrollY
      this.shrinked = window.scrollY >= 10
      this.updateAnimation()
    },
    updateAnimation(){
      // 轮播图标题
      this.animationAction("class",'VehicleSlider_title__6rPrq',0,'VehicleSlider_inView__XTMDy')
      // 轮播图内容
      this.animationAction("class",'VehicleSlider_vehicleSliderInnerWrapper__UOqKE',0,'VehicleSlider_inView__XTMDy')
      // 六恒科技
      // this.animationAction("class",'NioHouseSection_banner__H7xNP',0,'BSLSection_inView__YtbFj',false)
      // 六恒模块
      this.animationAction("class",'NioHouseSection_cardItem__bxgdZ',0,'NioHouseSection_inView__lLhOa',false)
      // 6s深度服务
      this.animationAction("class",'BSLSection_item__AbSIg',0,'BSLSection_inView__YtbFj',false)
    },
    animationAction(type, name, visibleH, flyName, isAdd=true){
      var doms = null
      if(type === 'Id'){
        doms = document.getElementById(name);
      }else{
        doms = document.getElementsByClassName(name);
      }
      if (!doms) {
        return;
      }
      // 遍历这些 DOM 元素
      for (var i = 0; i < doms.length; i++) {
        var dom = doms[i];
        // 如果元素已经有 "animated" 类，则跳过该元素
        if (dom.className.indexOf("animated") > -1) {
          continue;
        }
        // 获取元素的位置信息
        var domRect = dom.getBoundingClientRect();
        // 计算元素顶部距离窗口顶部的高度
        var domVisibleHeight = window.innerHeight - domRect.top;
        // 如果元素距离窗口顶部的高度大于 100 像素，开始动画
        if (domVisibleHeight > visibleH) {
          // 获取元素数据集中的动画类型，默认为 "fly-up"
          if(name === 'NioHouseSection_banner__H7xNP'){
            if(that.domVisibleHeight < 100){
              if(this.isScrollDown){
                that.domVisibleHeight += 2
                dom.style.width = that.domVisibleHeight + '%'
              }else{
                if(that.domVisibleHeight > 20){
                  that.domVisibleHeight -= 1
                  dom.style.width = that.domVisibleHeight + '%'
                }
              }
            }
          }else{
            if(isAdd){
              dom.classList.add(flyName)
            }else{
              dom.classList.remove(flyName)
            }
          }
        }else if(domVisibleHeight <= 0){
          if(name === 'NioHouseSection_banner__H7xNP'){
            if(that.domVisibleHeight >= 100){
              dom.style.width = '100%'
              that.domVisibleHeight = 100
            }
          }
          if(isAdd){
            dom.classList.remove(flyName)
          }else{
            dom.classList.add(flyName)
          }
        }
      }
    },
    onScroll() {
      // 获取所有具有 "animate-element" 类的 DOM 元素
      var doms = document.getElementById("animate-element");
      if (!doms) {
        return;
      }
      // 遍历这些 DOM 元素
      for (var i = 0; i < doms.length; i++) {
        var dom = doms[i];
        // 如果元素已经有 "animated" 类，则跳过该元素
        if (dom.className.indexOf("animated") > -1) {
          continue;
        }
        // 获取元素的位置信息
        var domRect = dom.getBoundingClientRect();
        // 计算元素顶部距离窗口顶部的高度
        var domVisibleHeight = window.innerHeight - domRect.top;
        // 如果元素距离窗口顶部的高度大于 100 像素，开始动画
        if (domVisibleHeight > 100) {
          dom.className = dom.className + " VehicleSlider_inView__XTMDy"
          // 获取元素数据集中的动画类型，默认为 "fly-up"
          // var animation = dom.dataset.animation || "fly-up";
          // // 获取元素数据集中的动画延迟时间
          // var animationDelay = dom.dataset.animationDelay;
          // // 添加 "animated" 类以标识元素已经被动画
          // dom.className = dom.className + " animated";
          // if (!animationDelay) {
          //   // 如果没有动画延迟，立即添加动画类
          //   dom.className = dom.className + " " + animation;
          // } else {
          //   // 如果有动画延迟，使用 setTimeout 在指定延迟后添加动画类
          //   (function (_dom) {
          //     setTimeout(function () {
          //       _dom.className = _dom.className + " " + animation;
          //     }, animationDelay);
          //   })(dom);
          // }
        }
      }
    },
    /**
     * 初始化轮播
     */
    initSlider() {
      this.$nextTick(() => {
        // 视频
        $('.slider').slick({
          fade: true,
          speed: 0,
          autoplay: true,
          autoplaySpeed: 8000,
          waitForAnimate: true,
          slidesToShow: 1,
          pauseOnHover: false
        });
        that.currentSlide = 0
        that.currentVideo = document.getElementById("myVideo0");
        if(that.currentVideo){
          that.currentVideo.play();
        }
        $('.slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          that.currentSlide = nextSlide
          var nextVideo = document.getElementById("myVideo"+nextSlide);
          if (that.currentVideo !== null) {
            that.currentVideo.pause();
            that.currentVideo.currentTime = 0
          }
          if(nextVideo){
            nextVideo.play();
            that.currentVideo = nextVideo;
          }
        });

        // 探索多元
        $('.slider1').slick({
          arrows: true,
          initialSlide: 0
        });
        $('.slider1').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
          that.currentSlide1 = currentSlide
        });
      });
    },
    /**
     * 轮播切换
     * @param index
     */
    paginationClick(index){
      $('.slider').slick('slickGoTo', index);
      // 重置动画
      // that.currentSlide = index
    },
    pagination1Click(index){
      $('.slider1').slick('slickGoTo', index);
      // 重置动画
      that.currentSlide1 = index
    },
    fetchNewsList(){
      fetchSixList().then(res=>{
        res.data.forEach(record =>{
          if(record.coverImage){
            record.coverImage = formatUrl(record.coverImage)
          }else{
            record.coverImage = ''
          }
        })
        this.newsList = res.data
      })
    },
    /**
     * 多元模块跳转
     * @param item
     * @param index
     */
    goPage(item,index){
      this.$router.push('/'+item.buttons.href)
    },
    goNews(){
      this.$router.push({
        path:'/news'
      })
    },
    newsClick(item,index){
      const routeData = this.$router.resolve({
        path: '/ndetail', // 假设已经定义了名为NewPage的路由
        query: {
          id: item.id,
          type:item.type
        }
      });
      window.open(routeData.href, '_blank');
    },
    goService(){
      this.$router.push({
        path:'/service'
      })
    },
    serviceClick(){
      this.$router.push({
        path:'/real'
      })
    },
    goDwell(){
      this.$router.push({
        path:'/dwell',
        query: {
          isFhMode: true,
        }
      })
    },
    /**
     * 六恒模块跳转
     */
    toDwell(){
      this.$router.push({
        path:'/dwell',
        query: {
          isSixMode: true,
        }
      })
    }
  }
}
</script>



<style>
@import '../../styles/header.css';
@import "../../styles/a9da.css";
@import "../../styles/footer.css";
@import "../../styles/a8ad.css";
@import "../../styles/a580.css";
@import "../../styles/a40f.css";
@import "../../styles/a824.css";
@import "../../styles/aef8.css";
</style>
